import React from 'react';

const ProgressBar = ({ progressPercentage , color,h=2 }) => {
  const clr=color || "bg-blue-500";
  return (
    <div className={`h-${h} w-full bg-gray-200 rounded-full overflow-hidden`}>
      <div 
        style={{ width: `${progressPercentage}%` }} 
        className={`h-full ${clr} rounded-full transition-all duration-500 ease-in-out`}
      ></div>
    </div>
  );
};

export default ProgressBar;